import { createJustText, JustText } from '@vfde-brix/ws10/just-text';
import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { HtmlId } from '../enums/elementId';
import { PreMarketingType } from '../enums/product';
import { formatAddressText } from '../util/formatter';
import { Address, AvcResult } from '@vfde-sails/avc-core';
import { getAvcResultAlternativeText } from '../container/AvailabilityCheck/util/result';

export const mountText = (wrapperId: HtmlId) =>
    createComponentById(createJustText, wrapperId, NO_PATTERN_BUSINESS_LOGIC);

export const updateAddressText = (comp: JustText | null, address?: Address) =>
    comp?.update({ content: formatAddressText(address) });

export const updateAlternativeText = (
    comp: JustText | null,
    avcResult: AvcResult,
    preMarketingType?: PreMarketingType,
) => {
    const alternativeText = getAvcResultAlternativeText(avcResult.fastest);

    comp?.update({ content: alternativeText });
    comp?.toggleContainer(avcResult.selectedAvailable || Boolean(preMarketingType));
};
